<template>
  <div v-loading="loading">
    <settings-card
      v-loading="loading"
      :config="config">
      <el-button
        type="text"
        @click="setting">去设置</el-button>
    </settings-card>
    <el-dialog
      :title="config.title"
      :visible.sync="visible"
      width="550px">
      <el-form
        ref="form"
        :rules="rules"
        :model="form">
        <el-form-item
          label="图片："
          prop="imageList">
          <desc-images
            v-model="form.imageList"
            :edit="true"></desc-images>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button
          type="primary"
          @click="submit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import DescImages from '@/components/public/desc-images.vue'
import SettingsCard from './settings-card.vue'
export default {
  name: 'IntegralStrategyCard',
  components: { DescImages, SettingsCard },
  props: {
    config: {
      type: Object,
      default() {
        return {}
      }
    },
    vendorId: [String, Number]
  },
  data() {
    return {
      loading: false,
      visible: false,
      form: {
        imageList: []
      },
      rules: {
        imageList: [
          { required: true, message: '请录入图片详情', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    setting() {
      this.getsetting(() => {
        this.visible = true
      })
    },
    getsetting(cb) {
      this.loading = true
      this.$store.dispatch('settings/getsetting', {
        payload: {
          vendorId: this.vendorId,
          settingType: this.config.type
        },
        success: res => {
          this.loading = false
          this.form = {
            ...res.data,
            imageList: res.data.data ? res.data.data.split(',').map(item => {
              // eslint-disable-next-line no-underscore-dangle
              const _arr = item.split('/')
              return {
                url: item,
                name: _arr[_arr.length - 1],
                type: /(\.mp4|\.3gp)$/g.test(item) ? 'video' : 'image',
                mediaType: /(\.mp4|\.webm|\.avi)$/g.test(item) ? 2 : 1
              }
            }) : []
          }
          // this.form.imageList.push({
          //   url: 'https://image.clousev.com/group1/M00/00/13/rBBUD10eP9OAVzBUAEgEjCxISA0535.mp4?originalfilename=产品介绍.mp4',
          //   name: '产品介绍.mp4',
          //   type: 'video'
          // })
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    submit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$store.dispatch('settings/configsetting', {
            payload: {
              vendorId: this.vendorId,
              settingType: this.config.type,
              data: this.form.imageList.map(i => i.url).join(','),
              settingName: '邀请合伙人页面'
            },
            success: () => {
              this.loading = false
              this.visible = false
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    }
  }
}
</script>
